<template>
    <div>
        <rkm-form
            v-if="!readonly"
            ref="Form"
        >
            <rkm-row class="flex-nowrap">
                <rkm-col cols="3">
                    <rkm-form-input
                        label="Número"
                        v-model="telefone.numero"
                        v-mask="numeroMask"
                        :validations="validations.numero"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Observação"
                        v-model="telefone.observacao"
                        :validations="validations.observacao"
                        uppercase
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="telefones"
            ref="Table"
            hide-filters
        >
            <template v-slot:cell(principal)="row">
                <rkm-form-radio
                    v-model="row.item.principal"
                    name="principal"
                    :value="true"
                    :disabled="readonly"
                    inline
                    @click.stop="selectPrincipal(row)"
                />
            </template>

            <template v-slot:cell(autorizaSms)="row">
                <template v-if="isFixo(row.item)">
                    <rkm-form-radio
                        disabled
                        inline
                    />
                </template>

                <template v-else>
                    <rkm-form-radio
                        v-model="row.item.autorizaSms"
                        name="autorizaSms"
                        :value="true"
                        :disabled="readonly"
                        inline
                        @click.stop="selectAutorizaSms(row)"
                    />
                </template>
            </template>

            <template v-slot:cell(actions)="{ index }">
                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(index)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Mixins.
import { mask, object } from '@/mixins'

export default {
    mixins: [ mask, object ],
    props: {
        readonly: { type: Boolean, default: false },
        telefones: { type: Array, required: true },
    },
    data: () => ({
        indexCheckedAutorizaSms: null,
        telefone: {
            id: null,
            numero: '',
            observacao: '',
            autorizaSms: false,
            principal: false,
        },
    }),
    computed: {
        validations() {

            return {
                numero: {
                    required: true,
                    min_max_without_mask: [10, 11]
                },
                observacao: {
                    max: 50
                }
            }
        },
        numeroMask() {

            if (this.telefone.numero === '') {

                return ''
            }

            return this.telefone.numero.length < 15 ? this.mask.phone : this.mask.cellPhone
        },
        fields() {

            const fields = [
                {
                    key: 'principal',
                    label: 'Principal',
                    class: 'col-min text-center'
                },
                {
                    key: 'autorizaSms',
                    label: 'SMS',
                    headerTitle: 'Autoriza recebimento de SMS',
                    class: 'col-min text-center'
                },
                { key: 'numero', label: 'Número', sortable: true },
                { key: 'observacao', label: 'Observação', sortable: true },
            ]

            if (!this.readonly) {

                fields.push({ key: 'actions', label: 'Ações', class: 'col-min' })
            }

            return fields
        }
    },
    methods: {
        async validate() {

            if (this.telefones.length === 0) {

                this.showValidationNotification('Obrigatório incluir pelo menos um telefone.')

                return false
            }
            else if (!this.telefones.find(t => t.principal === true)) {

                this.showValidationNotification('Obrigatório marcar um telefone como principal.')

                return false
            }

            return true
        },
        add() {

            const telefone = this.clone(this.telefone)

            if (this.telefones.length === 0) {

                telefone.principal = true
            }

            this.telefones.push(telefone)

            this.resetForm()
        },
        resetForm() {

            this.telefone.id = null
            this.telefone.numero = ''
            this.telefone.observacao = ''
            this.telefone.autorizaSms = false
            this.telefone.principal = false

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(index) {

            const destroy = async () => {

                this.telefones.splice(index, 1)

                if (this.telefones.length === 1) {

                    this.telefones[0].principal = true
                }
            }

            this.showDeleteConfirmation('Deseja realmente excluir o telefone?', destroy)
        },
        isFixo({ numero }) {

            return numero.length === 14
        },
        selectPrincipal({ index }) {

            if (!this.readonly) {

                this.telefones.map((_, i) => i !== index && (this.telefones[i].principal = false))
                this.telefones.map((_, i) => i == index && (this.telefones[i].principal = true))
            }
        },
        selectAutorizaSms({ index }) {

            if (!this.readonly) {

                this.telefones.map((_, i) => i !== index && (this.telefones[i].autorizaSms = false))


                if (this.indexCheckedAutorizaSms !== null && this.indexCheckedAutorizaSms === index) {

                    this.indexCheckedAutorizaSms = null
                    this.telefones[index].autorizaSms = false
                }
                else {

                    this.indexCheckedAutorizaSms = index
                }

                this.telefones.map((_, i) => i == index && (this.telefones[i].autorizaSms = true))
            }
        },
    },
}
</script>